//Module Keys
let locales = {};

//Merge Views
import packagesMain from 'Modules/packages/views/main/lan/es';
import featureTab from 'Modules/packages/.components/featureTab/lan/es';
import packageOverview from 'Modules/packages/views/overview/lan/es';
import createEditPackage from 'Modules/packages/.components/createEditPackage/lan/es';
import deletePackage from 'Modules/packages/.components/deletePackage/lan/es';
import assignedToTab from 'Modules/packages/.components/assignedToTab/lan/es';
import packagesTab from 'Modules/packages/.components/tab/lan/es';

locales = { 
    ...locales, 
    ...packagesMain,
    ...featureTab,
    ...packageOverview,
    ...createEditPackage,
    ...deletePackage,
    ...assignedToTab,
    ...packagesTab
};

export default locales;